import './EventBooking.css'
import React, { useEffect, useState } from 'react';
import axios from "axios";
import { useParams } from "react-router-dom";
import { useSelectedItem } from "../context/store";
import Loginpopup from "../Navbar/Loginmodal";
import iziToast from 'izitoast';
import { FaLocationDot } from "react-icons/fa6";
import { SlCalender } from "react-icons/sl";
import 'izitoast/dist/css/iziToast.min.css';

export default function EventBooking() {
    const [quantity, setQuantity] = useState(1);


    const handleIncrement = () => setQuantity(quantity + 1);
    const handleDecrement = () => quantity > 1 && setQuantity(quantity - 1);

    const { selectedItem, handleItemClick } = useSelectedItem();
    const params = useParams();
    const [eventdetailsTicket, setEventdetailsTicket] = useState([]);
    const [eventdetails1, setEventdetails1] = useState({});
    const [responseMessage, setResponseMessage] = useState("");
    const [showResponse, setShowResponse] = useState(false);
    const [ticketCounts, setTicketCounts] = useState({});
    const [showLoginPopup, setShowLoginPopup] = useState(false);
    const [responseId, setResponseId] = useState("");
    const userdata = JSON.parse(localStorage.getItem("userData"));
    const [amount, setAmount] = useState(0);
    const [platefromfee, setPlatefromfee] = useState(50.00);

    const [useCarrotBalance, setUseCarrotBalance] = useState(true);


    const url = "https://partywitty.com/master/assets/uploads/";

    const clubid = new FormData();
    clubid.append("event_id", params.id);

    const loadScripts = (src) => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    const createRazorpayOrder = async (amount) => {
        try {
            const formdata1 = new FormData();
            formdata1.append("user_id", userdata ? userdata.id : null);
            formdata1.append("amount", amount);
            const response = await axios.post("https://partywitty.com/master/APIs/ClubEvent/createOrder", formdata1);
            console.log("orderid", response.data.order_id);
            const orderId = response.data.order_id;
            return orderId;
        } catch (error) {
            console.error("Error creating Razorpay order:", error);
            return null;
        }
    };

    const handleRazorpayScreen = async (orderId, amount) => {
        try {
            const res = await loadScripts("https://checkout.razorpay.com/v1/checkout.js");
            if (!res) {
                throw new Error("Failed to load Razorpay script");
            }
            const options = {
                // key: "rzp_live_V8WPfxrtHG2Bud",
                key: 'rzp_live_eF5Szxh3Z6WnaS',
                amount: amount * 100,
                currency: "INR",
                name: "partywitty",
                description: "Payment to partywitty",
                order_id: orderId,
                handler: async function (response) {
                    await verifyRazorpayPayment(response);
                    alert("Payment successful");
                    window.location.href = "/success";
                },
                prefill: {
                    name: "partywitty",
                    email: "partywitty@gmail.com",
                },
                theme: {
                    color: "#f4c438",
                },
                modal: {
                    ondismiss: async function () {
                        await verifyRazorpayPayment({ status: "failed" });
                        alert("Payment failed or dismissed");
                    }
                }
            };
            const paymentObject = new window.Razorpay(options);
            paymentObject.open();
        } catch (error) {
            console.error("Error opening Razorpay:", error);
            alert("Error processing payment. Please try again later.");
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!userdata) {
            setShowLoginPopup(true);
            return;
        }
        const selectedTickets = eventdetailsTicket.filter(ticket => ticketCounts[ticket.id] > 0);
        const qty = selectedTickets.map(ticket => ticketCounts[ticket.id]).join(',');
        const ticket_id = selectedTickets.map(ticket => ticket.id).join(',');
        const formdata = new FormData();
        formdata.append("user_id", userdata.id);
        formdata.append("qty", qty);
        formdata.append("ticket_id", ticket_id);
        formdata.append("platform", "web");

        try {
            const response = await axios.post("https://partywitty.com/master/APIs/ClubEvent/placeOrder", formdata);
            const data = response.data;
            if (data.status) {
                console.log('PlaceOrder Resp: ', data);

                if (data.data.rzp_order_id === "") {
                    window.location.href = "/success";
                } else {
                    await handleRazorpayScreen(data.data.rzp_order_id, data.data.net_payable_amount);
                }
            } else {
                setResponseMessage(data.msg || "Failed to book tickets");
            }
        } catch (error) {
            const msg = 'Error placing order';
            console.error(msg, error);
            alert(msg);
            setResponseMessage(msg);
        }
    };

    const verifyRazorpayPayment = async (razorpayResponse) => {
        try {
            const formdata = new FormData();
            formdata.append("response", JSON.stringify(razorpayResponse));
            const response = await axios.post("https://partywitty.com/master/APIs/ClubEvent/verifyRzpPayment", formdata);
            const verificationResponse = response.data;
            console.log("Verification Response:", verificationResponse);
            if (verificationResponse.status) {
                iziToast.success({
                    title: 'Success',
                    message: verificationResponse.msg,
                    timeout: 20000,
                    position: 'topCenter',// 20 seconds
                });
            } else {
                iziToast.error({
                    title: 'Error',
                    message: verificationResponse.msg,
                    timeout: 20000,
                    position: 'topCenter', // 20 seconds
                });
            }
        } catch (error) {
            console.error("Error verifying payment:", error);
            iziToast.error({
                title: 'Error',
                message: 'An error occurred while verifying the payment.',
                timeout: 20000,
                position: 'topCenter',// 20 seconds
            });
        }
    };

    const getTotalAmount = () => {
        return eventdetailsTicket.reduce((total, ticket) => {
            const count = ticketCounts[ticket.id] || 0;
            return total + ticket.price * count;
        }, 0);
    };
    const getTotalAmountForFreepass = () => {
        return gstAmount + amount
    };

    const handleCheckboxChange = (e) => {
        setUseCarrotBalance(e.target.checked);
    };

    useEffect(() => {
        axios
            .post(
                "https://partywitty.com/master/Api/getDataPost/eventTicketType",
                clubid
            )
            .then((response) => {
                if (response.data.status === "true") {
                    setEventdetailsTicket([]);
                } else {
                    setEventdetailsTicket(response.data.data);
                    if (response.data.data[0].ticket_type === "Free") {
                        setAmount(50.00);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            });

        axios
            .post(
                "https://partywitty.com/master/Api/getDataPost/eventDetails",
                clubid
            )
            .then((response) => {
                setEventdetails1(response.data.data[0]);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        if (Array.isArray(eventdetailsTicket) && eventdetailsTicket.length > 0) {
            const initialCounts = {};
            eventdetailsTicket.forEach((ticket) => {
                initialCounts[ticket.id] = 1; // default quantity is 1
            });
            setTicketCounts(initialCounts);
        }
    }, [eventdetailsTicket]);


    const handleTicketCountChange = (id, count) => {
        setTicketCounts((prevCounts) => {
            const newCount = Math.max(count, 0);
            const updatedCounts = { ...prevCounts, [id]: newCount };
            if (newCount === 0) {
                delete updatedCounts[id];
            }
            return updatedCounts;
        });
    };

    const [gstAmount, setGstAmount] = useState(0);

    const calculateGst = (amount) => {
        const gstPercentage = 18;
        const gstAmount = (amount * gstPercentage) / 100;
        setGstAmount(gstAmount);
    }

    useEffect(() => {
        calculateGst(amount);
    }, [amount]);

    const handleItemClickEnhanced = (ticket) => {
        handleItemClick(ticket);
        setTicketCounts((prevCounts) => ({
            ...prevCounts,
            [ticket.id]: prevCounts[ticket.id] || 1,
        }));
    };

    const selectedTicketsAll = eventdetailsTicket.filter(ticket => ticketCounts[ticket.id] > 0);

const totalQty = selectedTicketsAll.reduce((total, ticket) => {
  return total + ticketCounts[ticket.id];
}, 0);


    return (
        <>
            <div className="event-booking-page">
                <div className="event-booking-container">
                    <div className='event-booking-wrapper'>
                        <div className="event-booking-order-summary">
                            <h2>Order Summary</h2>

                            <div className="event-booking-event-info">
                                <h4>{eventdetails1.name}  <span> &nbsp; &nbsp;( {eventdetails1.categoryName})</span></h4>
                                <p>{eventdetails1.clubName}</p>
                                <div className='event-booking-event-address-data'>
                                    <p><FaLocationDot />{eventdetails1.clubAddress}</p>
                                    <p><SlCalender />{eventdetails1.event_date} | {eventdetails1.event_time} </p>
                                </div>
                                <div className="event-booking-price-row">
                                    {Array.isArray(eventdetailsTicket) &&
                                        eventdetailsTicket.map((ticket) => (
                                            <div key={ticket.id} className="event-booking-ticket-card"
                                                onClick={() => handleItemClickEnhanced(ticket)} >
                                                <div>

                                                    <p className="event_ticket_name">{ticket.name}</p>
                                                    <p className="event_ticket_price">
                                                        {Number(ticket.price) === 0 ? "Free" : `@ INR ${ticket.price}/-`}
                                                    </p>
                                                    <p
                                                        className="event_ticket_contain"
                                                        dangerouslySetInnerHTML={{ __html: ticket.des }}
                                                    ></p>

                                                    {/* <div className="event-booking-price-discount">
                                                ₹2000
                                                <span className="event-booking-discount">
                                                    /person (20% off on Booking)
                                                </span>
                                            </div> */}
                                                </div>

                                                <div className="event-booking-counter">
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleTicketCountChange(ticket.id, (ticketCounts[ticket.id] || 1) - 1);
                                                        }}
                                                    >
                                                        -
                                                    </button>
                                                    <span>{ticketCounts[ticket.id] || 1}</span>
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleTicketCountChange(ticket.id, (ticketCounts[ticket.id] || 1) + 1);
                                                        }}
                                                    >
                                                        +
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                </div>


                                <div className="event-booking-carrot-section">
                                    <div className='event-booking-available-carrot'>Available balance: 🥕{userdata?.virtual_wallet}</div>
                                    <div className="dashed-divider" />
                                    <label><input type="checkbox" checked={useCarrotBalance}
                                        onChange={handleCheckboxChange} /> Pay Using Carrot Balance</label>
                                    <div className='event-booking-available-carrot-balance'>Usable Carrot Balance: 🥕50</div>
                                </div>

                                <div className="event-booking-summary-table">
                                    <div>
                                        <span>Grand Total</span>
                                        <span>Rs {eventdetailsTicket[0]?.ticket_type === "Free" ? getTotalAmountForFreepass() : getTotalAmount()}.00</span>
                                    </div>

                                    {useCarrotBalance && (
                                        <div>
                                            <span className="event-booking-red">Used Carrots</span>
                                            <span className="event-booking-red">-Rs 50.00</span>
                                        </div>
                                    )}

                                    <div className='event-booking-coupon-discount-section'>
                                        {/* <span>Coupon Discount</span>
                                        <span className="event-booking-blue">-Rs.400.00</span> */}
                                    </div>
                                    <div>
                                        <div className='event-booking-booking-amount'>
                                            <span>Booking Amount (Pay Now)</span>
                                            <span className='event-booking-gst-platform'>(30% of Grand Total)</span>
                                        </div>
                                        <span>Rs {eventdetailsTicket[0]?.ticket_type === "Free" ? getTotalAmountForFreepass() : getTotalAmount()}.00</span>
                                    </div>
                                    <div>
                                        <span className="event-booking-strike">Platform & Other Charges</span>
                                        <span className="event-booking-strike">Rs.60.00</span>
                                    </div>
                                    <div className='event-booking-gst-platform'>
                                        <span>GST</span>
                                        <span>Rs {gstAmount}.00</span>
                                    </div>
                                    <div className='event-booking-gst-platform'>
                                        <span>Platform Fee</span>
                                        <span>Rs {platefromfee}.00</span>
                                    </div>
                                    <div className="event-booking-bold">
                                        <span>Amount Payable</span>
                                        <span>Rs {eventdetailsTicket[0]?.ticket_type === "Free" ? getTotalAmountForFreepass() : getTotalAmount()}.00</span>
                                    </div>
                                </div>

                                <div className="event-booking-footer">
                                    <div className='event-booking-footer-bottom'>
                                    <div className="event-booking-total">₹{eventdetailsTicket[0]?.ticket_type === "Free" ? getTotalAmountForFreepass() : getTotalAmount()}.00<br /><small>{totalQty || 1} Ticket</small></div>
                                    <button onClick={handleSubmit}>Pay Now</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showLoginPopup && <Loginpopup />}
        </>
    );
};

